import { PermissionType } from 'api/types/entity';

import { RoutesId } from './routesId';

type PagesPermissionsType = {
  permissions: PermissionType[];
};

type PagesPermissions = Partial<Record<RoutesId, PagesPermissionsType>>;

export const pagesPermissions: PagesPermissions = {
  [RoutesId.admins]: {
    permissions: [PermissionType.User_GetList],
  },
  [RoutesId.admin]: {
    permissions: [PermissionType.User_GetOne, PermissionType.User_UpdateOne],
  },
  [RoutesId.administration]: {
    permissions: [
      PermissionType.SystemSetting_GetOne,
      PermissionType.SystemSetting_UpdateOne,
      PermissionType.User_GetList,
    ],
  },
  [RoutesId.clients]: {
    permissions: [PermissionType.Client_LegalClient_GetList],
  },

  [RoutesId.orders]: {
    permissions: [PermissionType.Order_GetList],
  },
  [RoutesId.createOrder]: {
    permissions: [PermissionType.Order_CreateOne],
  },
  [RoutesId.directories]: {
    permissions: [PermissionType.Directory_GetList],
  },
  [RoutesId.createDirectoryRecord]: {
    permissions: [PermissionType.Directory_UpdateOne],
  },
  [RoutesId.createOperation]: {
    permissions: [
      PermissionType.Operation_CreateOneViaList,
      PermissionType.Operation_CreateOneViaOrder,
    ],
  },
  [RoutesId.operation]: {
    permissions: [PermissionType.Operation_GetOne],
  },
  [RoutesId.operations]: {
    permissions: [PermissionType.Operation_GetList],
  },
  [RoutesId.formFM1]: {
    permissions: [PermissionType.Fm1Form_Access],
  },
};
